import { render, staticRenderFns } from "./noneDinner.vue?vue&type=template&id=4e463f1b&"
import script from "./noneDinner.vue?vue&type=script&lang=js&"
export * from "./noneDinner.vue?vue&type=script&lang=js&"
import style0 from "./noneDinner.vue?vue&type=style&index=0&id=4e463f1b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports